import { useEffect, useState } from "react";
import ConsultationModal, {
  ConsultationVariant,
  ConsultationIntent,
} from "./ConsultationModal";
import { record } from "@/lib/journey";


const GlobalConsultationListener = () => {
  const [open, setOpen] = useState(false);
  const [variant, setVariant] = useState<ConsultationVariant>("consultation");
  const [intent, setIntent] = useState<ConsultationIntent>("design");

  useEffect(() => {
    const handler = (e: Event) => {
      const custom = e as CustomEvent<{
        variant?: ConsultationVariant;
        intent?: ConsultationIntent;
      }>;
      const v = custom.detail?.variant ?? "consultation";
      // Back-compat: legacy "consultation" intent maps to "design".
      const rawIntent = custom.detail?.intent;
      const i: ConsultationIntent =
        rawIntent === "value_analysis"
          ? "value_analysis"
          : rawIntent === "labs" || v === "demo"
            ? "labs"
            : "design";
      setVariant(v);
      setIntent(i);
      setOpen(true);
      record("consultation_modal_open", `${v}:${i}`);
    };

    window.addEventListener("open-consultation", handler as EventListener);
    return () => window.removeEventListener("open-consultation", handler as EventListener);
  }, []);

  return (
    <ConsultationModal
      open={open}
      onOpenChange={setOpen}
      variant={variant}
      defaultIntent={intent}
    />
  );
};

export default GlobalConsultationListener;
